import {combineReducers} from "redux";
import setResult from "./setResult";

const setResultConfigReducer = combineReducers({
    setResult
});

export default setResultConfigReducer;
